import { Add, Warning } from '@mui/icons-material';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';

type NotAvailableBankAccountsTitleProps = {
  setOpenCreateAvailableDialog: () => void;
};

const NotAvailableBankAccountsTitle = ({
  setOpenCreateAvailableDialog,
}: NotAvailableBankAccountsTitleProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ width: '100%' }}
    >
      <Box
        sx={{
          backgroundColor: 'orange',
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
        }}
      >
        <Warning sx={{ fontSize: '1rem' }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          El cliente no tiene cuentas de banco registradas
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={setOpenCreateAvailableDialog}
        sx={{
          color: 'primary.main',
          backgroundColor: 'grey.50',
          border: '1px solid',
          borderColor: 'grey.200',
          '&:hover': {
            backgroundColor: 'grey.100',
            borderColor: 'grey.300',
          },
          '&:disabled': {
            color: 'grey.400',
            backgroundColor: 'grey.100',
            borderColor: 'grey.200',
          },
          borderRadius: '100px',
          padding: '4px 12px',
        }}
      >
        <Add sx={{ fontSize: '1rem', paddingRight: '4px' }} />
        <Typography variant="caption" fontWeight={600}>
          Crear
        </Typography>
      </IconButton>
    </Stack>
  );
};

export default NotAvailableBankAccountsTitle;
